import React, { useEffect, useState, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { isEqual } from 'lodash'
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { isMobileOnly } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import 'react-datepicker/dist/react-datepicker.css';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import {
  getBestTimesReportData,
  handleLoader
} from '../../../../redux/actions/BestTimesReportAction';
import BestTimeChart from './BestTimeChart'
import { vendorNameMapping } from '../../helper';

export const filterShowWise = [{
  label: "All", value: "All"
}, {
  label: "Product Category", value: "productCategory"
},
{
  label: "Product Collection", value: "productCollection"
},

{
  label: "Product Sub Category", value: "productSubCategory"
},
{
  label: "SKU Code", value: "sku"
},
]

const BestTimesReportIndex = ({ dispatch, rtl, vendor }) => {
  const { t } = useTranslation('common');
  const location = useLocation();

  const { isLoading, bestTimesReportData, salesChannelFilterData } = useSelector(
    ({ bestReportsReportReducer, marketPlaceReducer }) => ({
      salesChannelFilterData: marketPlaceReducer.salesChannel,
      bestTimesReportData: bestReportsReportReducer?.[vendor]?.bestTimesReportData,
      isLoading: bestReportsReportReducer?.[vendor].isLoading,
    }),
  );
  const currentlyShowRef = useRef({});
  const salesChannelRef = useRef({})

  const [bestTimesReportDataToShow, setBestTimesReportDataToShow] = useState([]);
  const [showMarketPlaceMessage, setShowMarketPlaceMessage] = useState(false)
  const [currentlyShow, setCurrentlyShow] = useState(filterShowWise?.[0]);
  const [currentlyShowSelected, setCurrentlyShowSelected] = useState([]);
  const [filterData, setFilterData] = useState({});
  const [dateRange, setDateRange] = useState([
    new Date(moment().subtract(1, 'month')),
    new Date(moment()),
  ]);
  const [productCategoryOptions, setProductCategoryOptions] = useState([]);
  const [productSubCategoryOptions, setProductSubCategoryOptions] = useState([]);
  const [productCollectionOptions, setProductCollectionOptions] = useState([]);
  const [skuOptions, setSKUOptions] = useState([]);

  const [startDate, endDate] = dateRange;

  const filterShowWiseSubOptions = () => {
    const options = [];
    let arrayToIterate = []
    if (currentlyShow?.value === 'productCategory') {
      arrayToIterate = productCategoryOptions
    }

    if (currentlyShow?.value === 'productSubCategory') {
      arrayToIterate = productSubCategoryOptions
    }

    if (currentlyShow?.value === 'productCollection') {
      arrayToIterate = productCollectionOptions
    }

    if (currentlyShow?.value === 'sku') {
      arrayToIterate = skuOptions
    }

    arrayToIterate?.filterData?.forEach((item) => {
      if (item.longValue) {
        options.push({ value: item.longValue, label: item.key })
      }
    })

    return options
  }

  const selectedSubOptionsMap = currentlyShowSelected?.reduce((acc, item) => {
    acc[item.value] = item.value;
    return acc
  }, {})


  const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `${vendorNameMapping[vendor]}  Best Times Report ${new Date().getFullYear()}`,
    })
   
  }


  const filterBasedOnFilter = (item) => {

    const categBasedOn = currentlyShow?.value;
    if (categBasedOn !== 'All' && currentlyShowSelected.length) {
      if (selectedSubOptionsMap[item[categBasedOn]]) {
        return true
      }
      return false
    }

    return true;
  };

  const callApi = () => {
    if (vendor) {
      const data = {
        fromDate: moment(startDate).format('YYYY-MM-DD'),
        toDate: moment(endDate).format('YYYY-MM-DD'),
        salesChannel: vendor === 'shopify' ? ['shopify.com'] : filterData?.salesChannel?.map(item => item.value) || [],
        vendor
      }
      setShowMarketPlaceMessage(false)
      dispatch(handleLoader(true, vendor));
      dispatch(
        getBestTimesReportData(data),
      );
    }
  };

  const handleApplyDate = () => {
    callApi();
  };

  useEffect(() => {
    callApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentlyShowRef?.current !== currentlyShow?.value) {
      currentlyShowRef.current = currentlyShow?.value;
      setCurrentlyShowSelected([])
    }
  }, [currentlyShow?.value])

  useEffect(() => {
    let categOptions = [];
    let subCategOptions = [];
    let collectOptions = [];
    let data = [];
    let skuApiOptions = []
    categOptions = bestTimesReportData?.modal
      ?.filters?.[0] || []
    collectOptions = bestTimesReportData?.modal
      ?.filters?.[1] || [];
    subCategOptions = bestTimesReportData?.modal
      ?.filters?.[3] || [];
    skuApiOptions = bestTimesReportData?.modal
      ?.filters?.[2] || [];
    data = bestTimesReportData?.modal?.data || []

    setBestTimesReportDataToShow(data);
    setProductCategoryOptions(categOptions);
    setProductSubCategoryOptions(subCategOptions);
    setProductCollectionOptions(collectOptions);
    setSKUOptions(skuApiOptions)
  }, [bestTimesReportData, vendor]);
console.log(bestTimesReportData?.modal)
  useEffect(() => {
    const OptChennel = 'salesChannel';

    if (salesChannelFilterData && !isEqual(salesChannelFilterData, salesChannelRef?.current?.salesChannel || [])) {
      setShowMarketPlaceMessage(true)
      salesChannelRef.current = { [OptChennel]: salesChannelFilterData }
      setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesChannelFilterData]);

  const bestTimesReportDataToShowForDatesSelected = vendor === 'amazon' ? bestTimesReportDataToShow?.filter(item =>
    filterBasedOnFilter(item),
  ) : bestTimesReportDataToShow || [];

  const databyHour = {};

  bestTimesReportDataToShowForDatesSelected.forEach((item) => {
    if (item.dayHours && databyHour[item.dayHours]) {
      databyHour[item.dayHours].Sunday += Number(item.weekDay1Sun)
      databyHour[item.dayHours].Monday += Number(item.weekDay2Mon)
      databyHour[item.dayHours].Tuesday += Number(item.weekDay3Tue)
      databyHour[item.dayHours].Wednesday += Number(item.weekDay4Wed)
      databyHour[item.dayHours].Thursday += Number(item.weekDay5Thr)
      databyHour[item.dayHours].Friday += Number(item.weekDay6Fri)
      databyHour[item.dayHours].Saturday += Number(item.weekDay7Sat)
    } else {
      databyHour[item.dayHours] = {
        Sunday: Number(item.weekDay1Sun),
        Monday: Number(item.weekDay2Mon),
        Tuesday: Number(item.weekDay3Tue),
        Wednesday: Number(item.weekDay4Wed),
        Thursday: Number(item.weekDay5Thr),
        Friday: Number(item.weekDay6Fri),
        Saturday: Number(item.weekDay7Sat),
      }
    }
  });

  return (
    <Container className="dashboard">
      <Row className="monthly-subscription-order">
        <Col sm="12">
          <Card className="pb-3">
            <CardBody className="min-w-50 p-3">
              <div className="card__title mb-2">
                <h5 className="bold-text card__title-center"> {vendorNameMapping[vendor]}  Best Times </h5>
              </div >
              <Row className="align-items-center">

                <Col md="12">
                  <Row className="align-items-center">
                    <Col sm="2" className="pr-0">
                      <div className="form__form-group mb-0">
                        <span className="form__form-group-label">Show</span>
                        <div className="form__form-group-field">
                          <Select
                            value={currentlyShow}
                            options={filterShowWise}
                            clearable={false}
                            placeholder="Select "
                            className="select_filter"
                            onChange={value => setCurrentlyShow(value)}
                            classNamePrefix="react-select"
                          />
                        </div>
                      </div>
                    </Col>
                    <Col sm="2" className="pr-0">
                      <div className="form__form-group mb-0">
                        <span className="form__form-group-label">Show</span>
                        <div className="form__form-group-field">
                          <Select
                            value={currentlyShowSelected}
                            options={filterShowWiseSubOptions()}
                            clearable={false}
                            placeholder="Select "
                            className="select_filter"
                            onChange={value => setCurrentlyShowSelected(value)}
                            classNamePrefix="react-select"
                            isMulti
                          />
                        </div>
                      </div>
                    </Col>
                    <Col sm="4">
                      <div className="form__form-group mb-0">
                        <span className="form__form-group-label">Date</span>
                        <div className="form__form-group-field">
                          <div className="date-picker">
                            <DatePicker
                              dateFormat="MM/dd/yyyy"
                              selectsRange
                              startDate={startDate}
                              endDate={endDate}
                              onChange={(update) => {
                                setDateRange(update);
                              }}
                              withPortal={isMobileOnly}
                              value={`${moment(startDate).format('MM/DD/YYYY')} - ${endDate ? moment(
                                endDate,
                              ).format('MM/DD/YYYY') : 'Select End Date'}`}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col sm="4" style={{ top: '10px' }}>
                      <button
                        className="btn btn-sm btn-primary apply-date-button"
                        type="button"
                        onClick={handleApplyDate}
                      >
                        Apply
                      </button>
                      <button className="btn btn-sm btn-primary
                                             apply-date-button"  type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                      {showMarketPlaceMessage ? <small>*Hit Apply to fetch latest data </small> : ''}
                    </Col>                   
                  </Row>
                </Col>
              </Row>
            </CardBody >
          </Card >
        </Col >
      </Row >
      <div id="divToPrint" ref={container}>
      <Row className="show-sales-region">
        <Col md="12">
          <Card>
            <CardBody className="p-0">
              <div className="best-times" style={{ minHeight: '400' }}>
                <div>
                  {isLoading ? (
                    <div
                      style={{ minHeight: '400px' }}
                      className="row align-items-center justify-content-center"
                    >
                      <SmallLoader loading={isLoading} />
                    </div>
                  ) : (
                    <BestTimeChart
                      title="Best Times Report"
                      data={databyHour}
                      dir={rtl.direction}
                    />
                  )}
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      </div>
    </Container >
  );
};

BestTimesReportIndex.propTypes = {
  dispatch: PropTypes.func.isRequired,
  rtl: RTLProps.isRequired,
  vendor: PropTypes.number.isRequired
};

export default 
  connect(state => ({
    rtl: state.rtl,
  }))(BestTimesReportIndex)
;